import React from 'react';
import { Colors } from '../../../../../constants/colors.constants';
import { useTranslation } from 'react-i18next';
import EmptyStateSystem from '../../../../DesignSystem/EmptyStateSystem';
import { ScheduleTimeIcon, ChatIcon } from '../../../../../icons';
import {
  getHeightWeeklyPlan,
  getStringWithIcon
} from '../../../../../views/weeklyPlan/Commitments/wwp.helpers';
import PropTypes from 'prop-types';

export const EmptyWWPError = ({ type = 'OTHER_ERROR' }) => {
  const { t } = useTranslation();
  const { DARK_GRAY } = Colors;

  const ERROR_TYPES = {
    INVALID_WWP_RANGE: {
      icon: <ScheduleTimeIcon color={DARK_GRAY} />,
      description: getStringWithIcon({
        text: t('weekly_plan.empty_state.invalid_wwp_data'),
        icons: {
          CHAT_ICON: <ChatIcon key="chat" />
        }
      })
    },
    OTHER_ERROR: {
      icon: <ScheduleTimeIcon color={DARK_GRAY} />,
      description: getStringWithIcon({
        text: t('weekly_plan.empty_state.other_error'),
        icons: {
          CHAT_ICON: <ChatIcon key="chat" />
        }
      })
    }
  };

  if (!type || !ERROR_TYPES[type]) {
    return null;
  }

  return (
    <div
      style={{
        height: getHeightWeeklyPlan()
      }}>
      <EmptyStateSystem
        icon={ERROR_TYPES[type].icon}
        description={ERROR_TYPES[type].description}
        title={''}
        descriptionMaxWidth="630px"
        textButton={''}
        functionButton={null}
      />
    </div>
  );
};

EmptyWWPError.propTypes = {
  type: PropTypes.string
};
